exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".section-title[data-v-4f445a55] {\n  padding-bottom: 2em;\n}\n.back-row[data-v-4f445a55] {\n  margin-top: 1.5em;\n  margin-left: 1em;\n}\n.other-options[data-v-4f445a55] {\n  max-width: 26em;\n  margin: 0 auto;\n  padding: 0 0.5em;\n}\n.other-options >p[data-v-4f445a55] {\n  padding: 3em 0 2em;\n}\n.other-options button[data-v-4f445a55] {\n  width: 100%;\n  margin-bottom: 0.8em;\n}\n.cancel-sub-btn[data-v-4f445a55] {\n  padding: 2em 0;\n}\n", ""]);

// exports
